/* Bidiboo theme JS — vanilla, geen dependencies.
   Drawers, Ajax-cart (add/change), quick-add, varianten, cadeauhulp, aanbevelingen. */
(function () {
  'use strict';

  var SETTINGS = window.BBSettings || {};

  /* ---------------- Geld ---------------- */
  function numberFormat(value, decimals, thouSep, decSep) {
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return parts.length > 1 ? parts[0] + decSep + parts[1] : parts[0];
  }

  function formatMoney(cents) {
    var format = SETTINGS.moneyFormat || '€{{amount_with_comma_separator}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount_with_comma_separator';
    var value = cents / 100;
    var out;
    switch (key) {
      case 'amount_no_decimals':
        out = numberFormat(Math.round(value), 0, ',', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = numberFormat(Math.round(value), 0, '.', ',');
        break;
      case 'amount_with_comma_separator':
        out = numberFormat(value, 2, '.', ',');
        break;
      default:
        out = numberFormat(value, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function imgSize(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Drawers ---------------- */
  var overlay = null;

  function getOverlay() {
    if (!overlay) overlay = document.querySelector('[data-bb-overlay]');
    return overlay;
  }

  function openDrawer(id) {
    closeDrawers();
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    var ov = getOverlay();
    if (ov) ov.classList.add('is-open');
    document.body.classList.add('bb-lock');
  }

  function closeDrawers() {
    document.querySelectorAll('.bb-drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    var ov = getOverlay();
    if (ov) ov.classList.remove('is-open');
    document.body.classList.remove('bb-lock');
  }

  /* ---------------- Cart API ---------------- */
  function cartGet() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function cartAdd(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function cartChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ---------------- Cart drawer rendering ---------------- */
  function cartItemHtml(item) {
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="bb-cd__item-variant">' + escapeHtml(item.variant_title) + '</span>' : '';
    return '' +
      '<div class="bb-cd__item">' +
        '<img src="' + imgSize(item.image, 124) + '" alt="" loading="lazy" width="62" height="62">' +
        '<div class="bb-cd__item-main">' +
          '<a class="bb-cd__item-name" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<div class="bb-cd__item-row">' +
            '<div class="bb-cd__stepper">' +
              '<button type="button" data-cd-minus data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Minder">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-cd-plus data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Meer">+</button>' +
            '</div>' +
            '<span class="bb-cd__item-total">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="bb-cd__item-remove" data-cd-remove data-key="' + item.key + '" aria-label="Verwijderen">×</button>' +
      '</div>';
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    var drawer = document.getElementById('bb-cart-drawer');
    if (!drawer) return;
    var body = drawer.querySelector('[data-cd-body]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '' +
        '<div class="bb-cd__empty">' +
          '<span class="bb-cd__empty-star" aria-hidden="true">★</span>' +
          '<p class="bb-cd__empty-title">Je mandje is nog leeg…</p>' +
          '<p class="bb-cd__empty-sub">Tijd om iets leuks uit te zoeken!</p>' +
          '<button type="button" class="bb-btn bb-btn--cta" data-close-drawer>Verder winkelen</button>' +
        '</div>';
      return;
    }

    var threshold = parseInt(drawer.getAttribute('data-free-shipping-cents'), 10) || 2000;
    var subtotal = cart.items_subtotal_price;
    var pct = Math.min(100, Math.floor(subtotal / threshold * 100));
    var meter;
    if (subtotal >= threshold) {
      meter = '<p class="bb-cd__meter-text is-free">★ Joepie — je hebt gratis verzending!</p>';
    } else {
      meter = '<p class="bb-cd__meter-text is-rest">Nog ' + formatMoney(threshold - subtotal) + ' tot gratis verzending</p>';
    }

    body.innerHTML = '' +
      '<div class="bb-cd__meter">' + meter +
        '<div class="bb-cd__track"><div class="bb-cd__fill" style="width:' + pct + '%"></div></div>' +
      '</div>' +
      '<div class="bb-cd__items bb-scroll">' + cart.items.map(cartItemHtml).join('') + '</div>' +
      '<div class="bb-cd__foot">' +
        '<div class="bb-cd__totalrow">' +
          '<span class="bb-cd__sub">Subtotaal <small>incl. btw</small></span>' +
          '<span class="bb-cd__total">' + formatMoney(cart.total_price) + '</span>' +
        '</div>' +
        '<a class="bb-cd__checkout" href="/checkout">Afrekenen →</a>' +
        '<button type="button" class="bb-cd__continue" data-close-drawer>of verder winkelen</button>' +
      '</div>';
  }

  function refreshCart(open) {
    return cartGet().then(function (cart) {
      renderCart(cart);
      if (open) openDrawer('bb-cart-drawer');
      return cart;
    });
  }

  /* ---------------- Cadeauhulp ---------------- */

function normalizeGiftTag(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[–—−]/g, '-')  // andere soorten streepjes omzetten
    .replace(/\s+/g, '');     // alle spaties verwijderen
}

function getProductTags(product) {
  var tags = product && product.tags;

  if (Array.isArray(tags)) {
    return tags;
  }

  if (typeof tags === 'string') {
    return tags
      .split(',')
      .map(function (tag) {
        return tag.trim();
      })
      .filter(Boolean);
  }

  return [];
}

function getFirstAvailableVariant(product) {
  var variants = product && Array.isArray(product.variants)
    ? product.variants
    : [];

  return variants.find(function (variant) {
    return variant.available !== false;
  }) || variants[0] || null;
}

function priceToCents(price) {
  if (price == null || price === '') return 0;

  var numericPrice = parseFloat(
    String(price)
      .replace(',', '.')
      .replace(/[^\d.-]/g, '')
  );

  if (!Number.isFinite(numericPrice)) return 0;

  /*
   * Shopify /products.json geeft de prijs normaal als eurobedrag,
   * bijvoorbeeld "19.95". Daarom vermenigvuldigen we met 100.
   */
  return Math.round(numericPrice * 100);
}

function initGiftFinder(root) {
  var finders = [];

  if (root && root.matches && root.matches('[data-gift-finder]')) {
    finders.push(root);
  }

  if (root && root.querySelectorAll) {
    root.querySelectorAll('[data-gift-finder]').forEach(function (finder) {
      finders.push(finder);
    });
  }

  finders.forEach(function (finder) {
    if (finder.dataset.bbInit) return;

    finder.dataset.bbInit = '1';

    var state = {
      age: null,
      min: null,
      max: null,
      products: null,
      loading: false
    };

    var results = finder.querySelector('[data-gift-results]');
    var none = finder.querySelector('[data-gift-none]');
    var maxResults =
      parseInt(finder.getAttribute('data-max-results'), 10) || 2;

    function load() {
      if (state.products) {
        return Promise.resolve(state.products);
      }

      if (state.loading) {
        return Promise.resolve([]);
      }

      state.loading = true;

      var url = finder.getAttribute('data-source');

      if (!url) {
        console.error('Cadeauhulp: data-source ontbreekt.');
        state.products = [];
        state.loading = false;
        return Promise.resolve([]);
      }

      return fetch(url, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'Producten konden niet worden opgehaald. HTTP-status: ' +
              response.status
            );
          }

          return response.json();
        })
        .then(function (data) {
          state.products = Array.isArray(data.products)
            ? data.products
            : [];

          console.log(
            'Cadeauhulp: ' +
            state.products.length +
            ' producten geladen via ' +
            url
          );

          return state.products;
        })
        .catch(function (error) {
          console.error('Cadeauhulp:', error);
          state.products = [];
          return [];
        })
        .finally(function () {
          state.loading = false;
        });
    }

    function render() {
      if (!results) return;

      if (!state.age) {
        results.innerHTML = '';

        if (none) {
          none.hidden = true;
        }

        return;
      }

      var selectedAge = normalizeGiftTag(state.age);

      var matches = (state.products || [])
        .filter(function (product) {
          var tags = getProductTags(product);

          var hasAgeTag = tags.some(function (tag) {
            return normalizeGiftTag(tag) === selectedAge;
          });

          if (!hasAgeTag) {
            return false;
          }

          var variant = getFirstAvailableVariant(product);

          if (!variant) {
            return false;
          }

          var priceCents = priceToCents(variant.price);

          if (state.min != null && priceCents < state.min) {
            return false;
          }

          /*
           * De bovengrens is inclusief:
           * "Tot €20" bevat dus ook producten van precies €20.
           */
          if (state.max != null && priceCents > state.max) {
            return false;
          }

          return true;
        })
        .slice(0, maxResults);

      results.innerHTML = matches
        .map(function (product) {
          var variant = getFirstAvailableVariant(product);
          var image =
            product.images &&
            product.images[0] &&
            product.images[0].src;

          var priceCents = priceToCents(
            variant ? variant.price : 0
          );

          var addButton = variant && variant.available !== false
            ? '<button type="button"' +
                ' class="bb-quick-add bb-quick-add--small"' +
                ' data-quick-add' +
                ' data-variant-id="' + escapeHtml(variant.id) + '"' +
                ' data-product-url="/products/' +
                  escapeHtml(product.handle) + '"' +
                ' aria-label="In winkelwagen">+</button>'
            : '';

          return (
            '<div class="bb-gift-mini">' +
              '<img src="' +
                (image ? escapeHtml(imgSize(image, 160)) : '') +
                '" alt="' + escapeHtml(product.title) + '"' +
                ' loading="lazy" width="80" height="80">' +
              '<div class="bb-gift-mini__info">' +
                '<a class="bb-gift-mini__name"' +
                  ' href="/products/' +
                  escapeHtml(product.handle) +
                  '">' +
                  escapeHtml(product.title) +
                '</a>' +
                '<span class="bb-gift-mini__price">' +
                  formatMoney(priceCents) +
                '</span>' +
              '</div>' +
              addButton +
            '</div>'
          );
        })
        .join('');

      if (none) {
        none.hidden = matches.length > 0;
      }

      console.log('Cadeauhulp selectie:', {
        leeftijd: state.age,
        minimum: state.min,
        maximum: state.max,
        resultaten: matches.length
      });
    }

    finder.addEventListener('click', function (event) {
      var ageChip = event.target.closest('[data-gift-age]');
      var budgetChip = event.target.closest('[data-gift-budget]');

      if (!ageChip && !budgetChip) return;

      if (ageChip) {
        var selectedTag = ageChip.getAttribute('data-gift-age');

        state.age =
          state.age === selectedTag
            ? null
            : selectedTag;

        finder
          .querySelectorAll('[data-gift-age]')
          .forEach(function (chip) {
            chip.classList.toggle(
              'is-active',
              chip.getAttribute('data-gift-age') === state.age
            );
          });
      }

      if (budgetChip) {
        var minimum = budgetChip.getAttribute('data-min');
        var maximum = budgetChip.getAttribute('data-max');
        var wasActive = budgetChip.classList.contains('is-active');

        finder
          .querySelectorAll('[data-gift-budget]')
          .forEach(function (chip) {
            chip.classList.remove('is-active');
          });

        if (wasActive) {
          state.min = null;
          state.max = null;
        } else {
          budgetChip.classList.add('is-active');

          state.min =
            minimum !== null && minimum !== ''
              ? parseInt(minimum, 10)
              : null;

          state.max =
            maximum !== null && maximum !== ''
              ? parseInt(maximum, 10)
              : null;
        }
      }

      load().then(function () {
        render();
      });
    });

    /*
     * Producten meteen ophalen. Daardoor merk je direct in de console
     * wanneer de bron-URL niet werkt.
     */
    load();
  });
}

  /* ---------------- Aanbevelingen (product recommendations) ---------------- */
  function initRecommendations(root) {
    root.querySelectorAll('[data-recommendations]').forEach(function (el) {
      if (el.dataset.bbInit) return;
      el.dataset.bbInit = '1';
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            el.innerHTML = fresh.innerHTML;
          } else {
            var section = el.closest('.bb-related');
            if (section) section.hidden = true;
          }
        })
        .catch(function () {});
    });
  }

  /* ---------------- Varianten (PDP) ---------------- */
  function onVariantChange(select) {
    var option = select.options[select.selectedIndex];
    if (!option) return;
    var form = select.closest('form');
    var scope = form ? form.closest('[data-pdp]') || document : document;
    var price = option.getAttribute('data-price');
    var compare = option.getAttribute('data-compare');
    var available = option.getAttribute('data-available') === 'true';

    var priceEl = scope.querySelector('[data-price]');
    if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price, 10));

    var compareEl = scope.querySelector('[data-compare-price]');
    if (compareEl) {
      if (compare && parseInt(compare, 10) > parseInt(price, 10)) {
        compareEl.textContent = formatMoney(parseInt(compare, 10));
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var noteEl = scope.querySelector('[data-ship-note]');
    if (noteEl && price) {
      var threshold = parseInt(SETTINGS.freeShippingThreshold, 10) || 2000;
      noteEl.textContent = parseInt(price, 10) >= threshold
        ? 'gratis verzending'
        : 'gratis verzending vanaf ' + formatMoney(threshold);
    }

    var btn = form ? form.querySelector('[data-add-button]') : null;
    if (btn) {
      btn.disabled = !available;
      btn.textContent = available ? (btn.getAttribute('data-label') || 'Hup, in het mandje!') : 'Uitverkocht';
    }
  }

  /* ---------------- Events (gedelegeerd) ---------------- */
  document.addEventListener('click', function (e) {
    var t;

    if (e.target.closest('[data-open-menu]')) {
      e.preventDefault();
      openDrawer('bb-menu-drawer');
      return;
    }
    if (e.target.closest('[data-open-cart]')) {
      e.preventDefault();
      openDrawer('bb-cart-drawer');
      return;
    }
    if (e.target.closest('[data-close-drawer]') || e.target.closest('[data-bb-overlay]')) {
      closeDrawers();
      return;
    }

    t = e.target.closest('[data-quick-add]');
    if (t) {
      e.preventDefault();
      var variantId = t.getAttribute('data-variant-id');
      if (!variantId) return;
      t.disabled = true;
      cartAdd(variantId, 1)
        .then(function () { return refreshCart(true); })
        .catch(function () { window.location.href = t.getAttribute('data-product-url') || '/cart'; })
        .then(function () { t.disabled = false; });
      return;
    }

    t = e.target.closest('[data-cd-plus], [data-cd-minus]');
    if (t) {
      var delta = t.hasAttribute('data-cd-plus') ? 1 : -1;
      var qty = parseInt(t.getAttribute('data-qty'), 10) + delta;
      var inDrawer = !!t.closest('#bb-cart-drawer');
      var stepper = t.closest('.bb-cd__stepper');
      if (stepper) stepper.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      cartChange(t.getAttribute('data-key'), Math.max(0, qty)).then(function (cart) {
        if (inDrawer) renderCart(cart);
        else window.location.reload();
      });
      return;
    }

    t = e.target.closest('[data-cd-remove]');
    if (t) {
      var removeInDrawer = !!t.closest('#bb-cart-drawer');
      cartChange(t.getAttribute('data-key'), 0).then(function (cart) {
        if (removeInDrawer) renderCart(cart);
        else window.location.reload();
      });
      return;
    }

    t = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (t) {
      var input = t.closest('.bb-qty').querySelector('input');
      var val = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, val + (t.hasAttribute('data-qty-plus') ? 1 : -1));
      return;
    }

    t = e.target.closest('[data-thumb]');
    if (t) {
      e.preventDefault();
      var main = document.querySelector('[data-main-image]');
      if (main) {
        main.src = t.getAttribute('data-src');
        if (t.getAttribute('data-srcset')) main.srcset = t.getAttribute('data-srcset');
        if (t.getAttribute('data-alt') !== null) main.alt = t.getAttribute('data-alt');
      }
      document.querySelectorAll('[data-thumb]').forEach(function (th) { th.classList.remove('is-active'); });
      t.classList.add('is-active');
      return;
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort-select]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
      return;
    }
    if (e.target.matches('[data-variant-select]')) {
      onVariantChange(e.target);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get('id');
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var btn = form.querySelector('[data-add-button]');
    var errEl = form.querySelector('[data-form-error]');
    if (errEl) errEl.textContent = '';
    if (btn) btn.disabled = true;
    cartAdd(id, qty)
      .then(function () { return refreshCart(true); })
      .catch(function (err) {
        if (errEl) errEl.textContent = (err && err.description) || 'Oeps — dit lukte even niet. Probeer het opnieuw.';
      })
      .then(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ---------------- Init ---------------- */
  function init(root) {
    initGiftFinder(root || document);
    initRecommendations(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.Bidiboo = {
    formatMoney: formatMoney,
    openDrawer: openDrawer,
    closeDrawers: closeDrawers,
    refreshCart: refreshCart
  };
})();
